module.exports = __webpack_public_path__ + "img/icon1.5ab66053.png";